<template>
  <div class="row justify-content-center g-4">
      <div v-for="(item, index) in location" :key="index" class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <GridLayout :item="item" :border="border"/>
      </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref, onUnmounted } from 'vue';
import axios from 'axios';
import GridLayout from './grid-layout.vue';
import { useI18n } from 'vue-i18n';

defineProps({
  border: Boolean
});

const location = ref([]);
const { locale } = useI18n();
const currentPage = ref(1);
const totalPages = ref(1);
const loading = ref(false);
const observer = ref(null);
const fetchCities = async () => {
if (loading.value || currentPage.value > totalPages.value) return;
  loading.value = true;
  try {
    const response = await axios.get(`/cities?page=${currentPage.value}&lang=${locale.value}`);
    location.value.push(...response.data.data);
    totalPages.value = response.data.last_page;
    currentPage.value++;            
  } catch (error) {
      console.error("Error fetching cities:", error);
  } finally {
    loading.value = false;
  }
};
const setupObserver = () => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && !loading.value) {
      fetchCities();
    }
  });
  
  const sentinel = document.getElementById('scroll-sentinel');
  if (sentinel) observer.value.observe(sentinel);
};

onMounted(async () => {
  await fetchCities();
  setupObserver();
});

onUnmounted(() => {
  if (observer.value) observer.value.disconnect();
});
</script>
